/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.wrap table {
  width: 100%;
  position: relative;
  border-collapse: collapse;
}
.wrap thead tr {
  height: calc(var(--spacing, 0.25rem) * 12);
  --tw-drop-shadow-size: drop-shadow(0px 4px 3px var(--tw-drop-shadow-color, rgba(0 0 0 / 0.1)));
  --tw-drop-shadow: drop-shadow(var(--drop-shadow-01, 0px 4px 3px rgba(0 0 0 / 0.1)));
  filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  background-color: var(--color-gray-100, #f5f5f5);
}
.wrap tbody tr {
  margin-bottom: calc(var(--spacing, 0.25rem) * 2);
  height: calc(var(--spacing, 0.25rem) * 16);
}
.wrap tbody tr:hover {
  background-color: var(--color-neutral-100, oklch(97% 0 none));
}
.wrap th, .wrap td {
  vertical-align: middle;
}
.wrap th:first-child, .wrap td:first-child div {
  border-top-left-radius: var(--radius-lg, 0.5rem);
  border-bottom-left-radius: var(--radius-lg, 0.5rem);
}
.wrap th:last-child, .wrap td:last-child div {
  border-top-right-radius: var(--radius-lg, 0.5rem);
  border-bottom-right-radius: var(--radius-lg, 0.5rem);
}
.wrap th {
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  background-color: var(--color-gray-200, #e5e5e5);
  color: var(--color-emphasis-medium, #525252);
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  vertical-align: middle;
}
.wrap td {
  padding: 0px;
  padding-top: calc(var(--spacing, 0.25rem) * 2);
  color: var(--color-emphasis-high, #000);
}
.wrap tr:last-child td {
  padding-bottom: 0px;
}
.wrap td:first-child:before {
  box-sizing: border-box;
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  display: block;
  --tw-drop-shadow-size: drop-shadow(0px 4px 3px var(--tw-drop-shadow-color, rgba(0 0 0 / 0.1)));
  --tw-drop-shadow: drop-shadow(var(--drop-shadow-01, 0px 4px 3px rgba(0 0 0 / 0.1)));
  filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  background-color: var(--color-white, #fff);
  border-radius: var(--radius-lg, 0.5rem);
  height: calc(var(--spacing, 0.25rem) * 16);
  z-index: calc(10 * -1);
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
    }
  }
}
